module.exports = __webpack_public_path__ + "img/tulipaikka_original.e8934b5d.jpg";